import { useRouter } from 'next/router';
import React from 'react';

interface Promotion {
  concessionID: string;
  Banner_FR_Badge: string;
  Banner_EN_Badge: string;
  Banner_FR_Title: string;
  Banner_EN_Title: string;
  Banner_FR_Subtitle: string;
  Banner_EN_Subtitle: string;
  Banner_FR_Date: string;
  Banner_EN_Date: string;
  Banner_FR_Link: string;
  Banner_EN_Link: string;
  image?: string;
}

interface StorePromotionsProps {
  promotions: Promotion[];
}

const StorePromotions = ({ promotions }: StorePromotionsProps) => {
  const router = useRouter();
  const { locale } = router;

  const getLocalizedValue = (field: string, promo: Promotion) => {
    switch (locale) {
      case 'fr':
        return promo[`Banner_FR_${field}` as keyof Promotion] || '';
      case 'en':
      default:
        return promo[`Banner_EN_${field}` as keyof Promotion] || '';
    }
  };
  return (
    <section>
      <div className="sv-promo-carousel">
        <div
          id="customCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            {promotions.map((_: any, index: any) => (
              <button
                key={index}
                type="button"
                data-bs-target="#customCarousel"
                data-bs-slide-to={index}
                className={index === 0 ? 'active' : ''}
                aria-current={index === 0 ? 'true' : undefined}
                aria-label={`Slide ${index + 1}`}
              ></button>
            ))}
          </div>

          <div className="carousel-inner">
            {promotions.map((promo: any, index: any) => {
              const badge = getLocalizedValue('Badge', promo);
              const title = getLocalizedValue('Title', promo);
              const subTitle = getLocalizedValue('Subtitle', promo);
              const date = getLocalizedValue('Date', promo);
              const link = getLocalizedValue('Link', promo);
              return (
                <div
                  key={promo.concessionID}
                  className={`carousel-item  ${
                    index === 0 ? 'active' : ''
                  } banner-${promo.Banner_Color_Set}`}
                >
                  {promo.Only_Image ? (
                    <div className="carousel-item-img-full">
                      <img
                        src={promo?.image || 'Promotion Image'}
                        className="carousel-image-full"
                        alt="Promotion"
                      />
                    </div>
                  ) : (
                    <div className="row align-items-center">
                      {promo?.image && (
                        <div className="col-lg-4 col-md-4 col-sm-5 col-xs-4 col-4 carousel-item-align">
                          <div className="carousel-item-img">
                            <img
                              src={promo?.image || 'Promotion Image'}
                              className="carousel-image"
                              alt="Storage Image"
                            />
                          </div>
                        </div>
                      )}
                      <div
                        className={`sv-promo-carousel-responsive ${
                          promo?.image
                            ? 'col-lg-8 col-md-8 col-sm-7 col-6 col-xs-6'
                            : 'col-lg-12 col-md-12 col-sm-12 col-12 carousel-content-only'
                        }`}
                      >
                        <div className="carousel-content">
                          {/* Render badge only if it exists */}
                          {badge &&
                            (link ? (
                              <a href={link} className="sv-pill-link mb-2">
                                {badge}
                                <span className="sv-pill-arrow">
                                  <img src="/images/sv-pill-arrow.svg" alt="" />
                                </span>
                              </a>
                            ) : (
                              <span className="badge sv-pill-link mb-2">
                                {badge}
                              </span>
                            ))}
                          <h5 className="sv-gray-large-heading mb-1">
                            {title}
                          </h5>
                          <div className="d-flex justify-content-between">
                            <p className="sv-dark-black-bold-para mb-0">
                              {subTitle}
                            </p>
                            {link ? (
                              <a
                                href={link}
                                className="sv-offer-deadline text-decoration-none"
                              >
                                {date}
                              </a>
                            ) : (
                              <p className="sv-offer-deadline mb-0">{date}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#customCarousel"
            data-bs-slide="prev"
          >
            <span
              className="custom-carousel-icon carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#customCarousel"
            data-bs-slide="next"
          >
            <span
              className="custom-carousel-icon carousel-control-next-icon"
              aria-hidden="true"
            ></span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default StorePromotions;
